<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Alert"
      :ref="'userLocationPopup'"
      :id="'userLocationPopup'"
    >
    <div class="text-center pb-1">
        <p class="my-3 font-weight-bold">
          Do You Want to Switch to Default Cinema.
        </p>

        <button
          class="btn btn-sm btn-outline-danger"
          @click.prevent.stop="onCancelUserLocationPopUp(false)"
        >
          No
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-sm btn-primary"
          @click.prevent.stop="onChangeUserLocationDefault()"
        >
           Yes
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PosService from "@/services/PosService.js";

export default {
  props: {
    onCancelUserLocationPopUp: {
      type: Function
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onChangeUserLocationDefault() {
      let payload = {
        dflt_user_id: this.secureStore.get("DFLT_USINFO").user_id,
        new_user_id: this.secureStore.get("DFLT_USINFO").user_id
      }
      PosService.changeLoggedUserCinema(payload).then(async (response) => {
        const {data} = response;
        console.log('data', data);
        let finalObj = {};
        let PromiseArray = this.usersArray.map(x => {
          finalObj[x] = data.data.user[x] || null;
        });
        await Promise.all(PromiseArray);

         if (data.data.user && data.data.user.shift_id) {
                this.$store.dispatch("OnPOSLogin", true);
                
                this.secureStore.set("USINFO", finalObj);

                this.$cookie.set("BRHSID", data.data.token, {
                  expires: "1Y"
                });

                this.$store.dispatch("onSetAndSendLog", {
                  cinema_id: finalObj.cinema_id,
                  user_id: finalObj.user_id,
                  action: "POS User Logged In",
                  page_name: "POS LOGIN",
                  api_name: window.location.hash
                });

                this.$cookie.set("BRLF", "pos-login");
                window.localStorage.setItem("JWT_TOKEN", data.data.token);
                
                this.secureStore.set(
                  "BRCISH",
                  data.data.user.cine_include_shift_close
                );

                this.secureStore.set(
                  "BRCIFTAT",
                  data.data.user["cine_include_float_amount"]
                );

                this.$store.dispatch("userShiftStart", {
                  usl_id: data.data.user.user_id,
                  user_shift_id: data.data.user.shift_id,
                  cine_include_shift_close:
                    data.data.user.cine_include_shift_close,
                  cine_include_float_amount:
                    data.data.user.cine_include_float_amount
                });
                
                var userAgent = navigator.userAgent.toLowerCase();

                if (userAgent.indexOf(" electron/") > -1) {
                  if (backendSocket && backendSocket.connected) {
                    backendSocket.emit("on_user_login", {
                      user: data.data.user,
                      hardware_id: this.hardware_id
                    });
                  }
                }

                this.onCancelUserLocationPopUp(false)
              } else {
                this.$toasted.show(
                  "Shift is Not Created For Selected Location"
                );
              }
      }).catch((err) => {
        console.log('Error:', err);
      }).finally(() => {
          this.$refs.userLocationPopup.hide()
      })
    },
  },
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ChangeUserLocationPopUp.vue